function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.805 11.286H1.403V.143c0-.079-.07-.143-.156-.143H.156C.07 0 0 .064 0 .143v12.286c0 .078.07.142.156.142h14.65c.085 0 .155-.064.155-.142v-1c0-.079-.07-.143-.156-.143zm-12-1.143h10.442c.085 0 .156-.064.156-.143V2.214c0-.128-.17-.19-.267-.102L9.039 5.868 6.596 3.654a.164.164 0 0 0-.11-.042.164.164 0 0 0-.11.042L2.694 7.039a.14.14 0 0 0-.033.046.13.13 0 0 0-.012.054V10c0 .079.07.143.156.143z",
  fill: "#fff"
});

var SvgTrending = function SvgTrending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trending.b92a6eb9.svg";
export { ForwardRef as ReactComponent };